import {
  EmploymentType,
  MemberStatus,
  type Member,
  type MemberDocument,
  type MemberRole,
} from "@/features/members/model/members-types"

export const currentUserRole: MemberRole = "admin"
export const currentUserId = "current_admin_user"

export const membersMockData: Member[] = [
  {
    id: currentUserId,
    name: "Barack Mukelenga",
    firstName: "Barack",
    lastName: "Mukelenga",
    email: "barack.mukelenga@myadmin.io",
    role: "admin",
    team: "Administration",
    status: MemberStatus.Active,
    employmentType: EmploymentType.FullTime,
    lastActiveAt: "2026-01-01T08:00:00.000Z",
    joinedAt: "2025-01-01T08:00:00.000Z",
  },
]
export const memberDocumentsMockData: MemberDocument[] = []
